import axiosService from '@/services/axios/axios.service';
import { ReportData, ReportQuery, ReportResponse } from '@/models/report.model';

const getReports = async (payload: ReportQuery): Promise<ReportResponse> => {
    const response = await axiosService.get('/report/get-reports', {
        params: {
            day: payload.day,
            page: payload.page,
            limit: payload.limit,
            uid: payload.uid,
        },
    });
    return response.data;
};

const getReportById = async (id: string): Promise<ReportData> => {
    const response = await axiosService.get(`/report/get-detail-report/${id}`);
    return response.data;
};

export { getReports, getReportById };
